<template>
    <div class="auto">
        <img src="/static/img/one.png" />
        <div class="tips">
            <div class="title">多平台适用</div>
            <div class="sub-title">DUO PING TAI SHI YONG</div>
            <div class="labels">
                <div class="label-item">1、匹配国内有美团、饿了么、京东到家等多平台同步开店的需求，连接多个平台只需一台打印机。</div>
                <div class="label-item">2、同时无需人工值守，避免人工操作导致的接单混乱等意外。</div>
                <div class="label-item">3、自主开放平台支持第三方平台接口对接，无平台接入数量限制。</div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() { return {} }

}
</script>


<style scoped>
.auto {
    display: flex;
    margin-top: 20px;
    padding: 80px 240px;
}

.tips {
    text-align: left;
    flex: 1;
    margin-left: 30px;
}

.title {
    font-size: 60px;
}

.sub-title {
    color: #e2e2e2;
    font-size: 28px;
}

.labels {
    margin-top: 30px;
    color: #999;
}

.label-item {
    font-size: 18px;
}

.label-item+.label-item {
    margin-top: 20px;
}
</style>
<style>
.hoverSize .el-col {
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// homePage1.vue?076c5de6